// extracted by mini-css-extract-plugin
export default {"CandidateResumeSkills__description":"hpPNg"};